import { SettingsAPI } from '@business/api/settings';
import { IntegrationType } from '@business/entities/integration';
import { BaseBloc } from '@core/utils/bloc';
import { NmiPaymentFormData } from '@modules/settings/SettingsPage/Components/IntegrationsTab/NmiPaymentModal/NmiPaymentModal';
import { tap } from 'rxjs/operators';
import { PMService } from '@business/services/pm_service';

export class IntegrationHelperBloc extends BaseBloc {
  onInit() {
    SettingsAPI.fetchSettings(true)
      .pipe(
        tap(settings => {
          const nmi = settings.integrations.find(i => i.type === IntegrationType.nmi);
          if (nmi) {
            const settings = nmi.settings as NmiPaymentFormData;
            PMService.addNMIScript(settings.tokenizationKey);
          }
        }),
      )
      .subscribe();
  }

  onReset() {
    PMService.removeNMIScript();
  }
}
